import { z } from 'zod';

import { introspection_types } from '~/bigcommerce-graphql';

export type CountryCode = introspection_types['countryCode']['enumValues'];

export const countryCodeSchema = z
  .string()
  .length(2)
  .toUpperCase()
  .refine((val): val is CountryCode => /^[A-Z]{2}$/.test(val), {
    message: 'Must be a valid country code',
  })
  .default('GB');
